<template>
  <div class="footer-follow-us-section__wrapper">
    <p class="footer-follow-us-section__title bold">Follow Us</p>
    <footer-socials
      :items="footerSocials"
      class="footer-follow-us-section__socials"
    />
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import FooterSocials from './FooterSocials'

export default {
  name: 'FooterFollowUsSection',
  components: { FooterSocials },
  props: {
    footerSocials: propValidator([PROP_TYPES.ARRAY])
  }
}
</script>

<style lang="scss" scoped>
.footer-follow-us-section__wrapper {
  position: relative;
  width: 290px;
  display: flex;
  flex-direction: column;

  .footer-follow-us-section__title {
    font-size: 18px;
    line-height: 22px;
  }

  .footer-follow-us-section__socials {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
